import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Button, InputLabel, Stack} from '@mui/material';

import {ManageSuppliersServiceAvailability} from '@store/suppliers/services';

import {checkIfErrors, FieldValidationType, getFieldError} from '@utils/yup.utils';
import dayjs from '@utils/dayjs.utils';

import ModalComponent from '@components/modal/Modal.component';
import DatePickerComponent from '@components/inputs/datePicker/DatePicker.component';
import MultiTextFieldComponent from '@components/inputs/multiTextField/MultiTextField.component';

interface ManageAvailabilityModalProps {
  availability?: ManageSuppliersServiceAvailability;
  handleClose: () => void;
  handleSaved: (availability: ManageSuppliersServiceAvailability) => void;
}

const ManageAvailabilityModal = (props: ManageAvailabilityModalProps) => {
  const {availability: availabilityProps, handleClose, handleSaved} = props;

  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);

  const [availability, setAvailability] = useState<ManageSuppliersServiceAvailability>(availabilityProps || {});

  const errors = {
    availableFrom: getFieldError(availability.availableFrom, FieldValidationType.REQUIRED_DATE),
    //availableTo: getFieldError(availability.availableTo, FieldValidationType.REQUIRED_DATE),
  };

  return (
    <ModalComponent
      aria-label="over-drawer"
      handleClose={handleClose}
      title={t(`suppliers.details.catalog.manage.manageAvailability.title.${!availabilityProps ? 'add' : 'edit'}`)}
      content={(
        <Stack width="75%" spacing={2} pt="55px" pb="10px">
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <InputLabel sx={{width: 126}}>
              {t('suppliers.details.catalog.manage.serviceValidity')}*
            </InputLabel>
            <Box flex={0.5}>
              <DatePickerComponent
                color="secondary"
                label={t('global.dateFrom')}
                placeholder={t('global.selectDate')}
                handleChange={(availableFrom) =>
                  setAvailability((state) => ({
                    ...state,
                    availableTo: state.availableTo && dayjs(state.availableTo).isBefore(availableFrom) ? availableFrom : state.availableTo,
                    availableFrom: availableFrom,
                  }))
                }
                error={errors.availableFrom}
                value={availability.availableFrom}/>
            </Box>
            <Box flex={0.5}>
              <DatePickerComponent
                color="secondary"
                label={t('global.dateTo')}
                placeholder={t('global.selectDate')}
                handleChange={(availableTo) =>
                  setAvailability((state) => ({
                    ...state,
                    availableFrom: state.availableFrom && dayjs(state.availableFrom).isAfter(availableTo) ? availableTo : state.availableFrom,
                    availableTo: availableTo,
                  }))
                }
               // error={errors.availableTo}
                value={availability.availableTo}/>
            </Box>
          </Stack>
          <MultiTextFieldComponent
            color="secondary"
            labelWidth={160}
            label={t('suppliers.details.catalog.manage.zipCodeHandled')}
            placeholder={t('global.writeSomething')}
            handleChange={(availableZipCodes) => setAvailability((state) => ({...state, availableZipCodes}))}
            values={availability.availableZipCodes || []}/>
        </Stack>
      )}
      actions={(
        <>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            {t('global.cancel')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={loading || checkIfErrors(errors)}
            onClick={() => {
                setLoading(true);
              if (!availabilityProps?.id) {
                  const newAvailability = availability;
                  // if (newAvailability.availableTo === undefined) {
                  //     newAvailability.availableTo = new Date();
                  //     newAvailability.availableTo.setFullYear(9999);
                  // }
                handleSaved(newAvailability);
                handleClose();
              }
            }}>
            {t('global.save')}
          </Button>
        </>
      )}/>
  );
};

export default ManageAvailabilityModal;
